import { MaterialProvider } from "./materialContext";
import { ModelProvider } from "./modelStore";
import { ProductProvider } from "./productContext";
import { SettingsProvider } from "./settingsStore";

function Providers({ children }) {
  return (
    <>
      <SettingsProvider>
        <ProductProvider>
          <ModelProvider>
            <MaterialProvider>{children}</MaterialProvider>
          </ModelProvider>
        </ProductProvider>
      </SettingsProvider>
    </>
  );
}

export default Providers;
